import { Dialog, DialogContent } from "@mui/material";
import { clearAllCardSelection, setActiveActionCard } from "components/app/App.slice";
import Stepper from "components/common/Stepper";
import Typography from "components/common/Typography";
import Form from "components/features/MyPlans/Create/Form";
import InviteMemberDialog from "components/features/planDetails/InviteMemberDialog";
import { useTranslate } from "hooks/useTranslate";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { formTypes } from "utils/Types";
import MyPlanDetails from "../MyPlanDetails";
import { setIsViewMode } from "../MyPlanDetails/MyPlanDetails.slice";
import { setCopySectionData } from "../planDetails/PlanDetail.slice";
import { reset, setCurrentStep, setPlanMode } from "./CustomPlanCreation.slice";
import CustomPlanCreationFooter from "./Footer";
import "./index.scss";

interface Props {
  handleCloseDialog: () => void;
  open?: boolean;
  actionPayload: any;
  sectionPayload: any;
}

const CustomPlanCreation = (props: Props) => {
  const { open = false, handleCloseDialog, ...formProps } = props;

  const formRef = React.useRef<any>(null);

  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const { flow, currentStep, planMode, totalSteps } = useAppSelector((state) => state.CustomPlanCreation);
  const myPlanDetails = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  useEffect(() => {
    dispatch(setIsViewMode(true));
    return () => {
      dispatch(clearAllCardSelection());
      dispatch(setActiveActionCard({}));
      dispatch(setCopySectionData({}));
      dispatch(setIsViewMode(false));
      dispatch(setPlanMode(""));
      dispatch(reset());
    };
  }, []);

  const renderComponent = (): JSX.Element | null => {
    if (flow) {
      switch (flow[currentStep]) {
        case `${translate("custom.plan.creation.step2")}`:
        case `${translate("custom.plan.creation.step0")}`:
          return <MyPlanDetails skipResetDetailsOnUnmount />;

        case `${translate("custom.plan.creation.step3")}`:
          return <InviteMemberDialog getForm />;

        default:
          return <Form ref={formRef} formType={myPlanDetails.id ? formTypes.EditPlan : planMode} {...formProps} />;
      }
    }
    return null;
  };

  const handleStepper = (index: number) => {
    dispatch(setCurrentStep(index));
  };

  return (
    <>
      {open && (
        <Dialog fullScreen open={true} onClose={() => handleCloseDialog()} className={`custom_plan_creation`}>
          <DialogContent className="content-wrapper">
            <div className="custom-plan-creation-flow-container">
              <div className="right-wrapper">
                <div id="right-wrapper-container" className="right-wrapper-container">
                  <div className="heading-container">
                    <div>
                      <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
                        {totalSteps == 1 ? translate("common.addToMyPlans") : translate("custom.plan.creation.title")}
                      </Typography>
                    </div>
                  </div>
                  <div className="content-main-container">
                    <div className="stepper-component">
                      <Stepper
                        setCurrentStep={handleStepper}
                        flow={flow}
                        currentStep={currentStep}
                        color={tokens.Text.General.Secondary}
                      />
                    </div>
                    <div className={`component-render ${flow[currentStep].trim().toLowerCase().replace(/\s+/g, "-")}`}>
                      {renderComponent()}
                    </div>
                  </div>
                </div>
                <div className="action-footer">
                  <CustomPlanCreationFooter {...props} formRef={formRef} />
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CustomPlanCreation;
